import { ACCOUNT_HOST } from 'config';
import { AccountService } from 'shared/inter-service/account';
import { getUrlToLoginCallbackPage } from "pages/urls";

export const accountService = AccountService(ACCOUNT_HOST, getUrlToLoginCallbackPage());
